// ============================================================
// Push Notification Subscription Utility
// Call subscribeToPush() after user logs in
// ============================================================
import API from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw     = window.atob(base64);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

export async function subscribeToPush() {
  try {
    // Check browser support
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

    // This path never prompts. It used to call Notification.requestPermission()
    // *after* awaiting the VAPID key fetch, which Safari rejects outright — by
    // then the user gesture that triggered it has already been spent. Prompting
    // is owned by useFcmPush.js, which asks first and awaits afterwards; here we
    // simply do nothing until permission is already granted.
    if (!("Notification" in window) || Notification.permission !== "granted") return;

    // Get VAPID public key from backend
    const { data } = await API.get("/push/vapid-public-key");
    if (!data.publicKey) return; // Push not configured on server

    // Get service worker registration
    const registration = await navigator.serviceWorker.ready;

    // Check if already subscribed
    const existing = await registration.pushManager.getSubscription();
    if (existing) {
      // Re-send to backend in case it was lost
      await API.post("/push/subscribe", { subscription: existing });
      return;
    }

    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly     : true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });

    // Save to backend
    await API.post("/push/subscribe", { subscription });
    console.log("✅ Push notifications enabled");
  } catch (err) {
    console.log("Push subscription skipped:", err.message);
  }
}
